module.exports = __webpack_public_path__ + "assets/search-f49fd279b9976666b9ef88178fe5d631.svg";